export const getCampaignId = (link: string) => {
  return link.split('/').reverse()[0] || '';
};

export const calculateRevenue = (price: string, count: number) => {
  return parseFloat(price) * count;
};

export const calculateIncome = (revenue: number, commission: number) => {
  return revenue * (commission / 100);
};

export const calculateArpu = (revenue: number, count: number) => {
  return count > 0 ? (revenue / count).toFixed(3) : '0.000';
};

export const calculateArpd = (revenue: number, activeCount: number | null) => {
  return activeCount && activeCount > 0 ? (revenue / activeCount).toFixed(3) : '0.000';
};

export const calculateRomi = (revenue: number, cost: number) => {
  return cost > 0 ? ((revenue - cost) / cost) * 100 : 0;
};
